'use client';

import { LifeProduct } from '@app/domain/model/eshop/life/LifeProduct';
import { ChoiceButtonInput } from '@app/app/_components/Input/ChoiceButtonInput';
import { useState, ChangeEvent } from 'react';
import { useChangeEffect } from '@app/lib/use-change-effect/useChangeEffect';
import { ViolationMap } from '@app/lib/form/contracts/ViolationMap';
import { ViolationMessage } from '@app/lib/form/contracts/ViolationMessage';

interface Props {
    transportationMeans: LifeProduct[];
    error?: ViolationMap | ViolationMessage;
    defaultChecked?: string[];
    onTransportationMeansChange?: () => void;
}

export function TransportationMeansStep({
    transportationMeans,
    error,
    defaultChecked,
    onTransportationMeansChange,
}: Props) {
    const [selected, setSelected] = useState<string[]>(defaultChecked ?? []);

    useChangeEffect(() => {
        onTransportationMeansChange?.();
    }, selected);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target;
        setSelected(prev => (checked ? [...prev, value] : prev.filter(v => v !== value)));
    };

    return (
        <ChoiceButtonInput
            name="transportationMeans"
            type="checkbox"
            error={error}
            options={transportationMeans.map(option => ({
                value: option.code,
                label: option.value,
            }))}
            value={selected}
            onChange={handleChange}
        />
    );
}
